import type React from "react";
import { useMatchingResults } from "../../../hooks/use-matching-results-api";
import { MatchingResultsPage as MatchingResultsPagePresentation } from "./MatchingResultsPage";

/**
 * マッチング結果一覧ページ Container
 * @return {JSX.Element} MatchingResultsPage コンポーネント
 */
export const MatchingResultsPage: React.FC = () => {
  const {
    results,
    total,
    page,
    limit,
    loading,
    error,
    filters,
    sort,
    setPage,
    setFilters,
    setSort,
  } = useMatchingResults();

  return (
    <MatchingResultsPagePresentation
      results={results}
      total={total}
      page={page}
      limit={limit}
      loading={loading}
      error={error}
      filters={filters}
      sort={sort}
      onPageChange={setPage}
      onFiltersChange={setFilters}
      onSortChange={setSort}
    />
  );
};

export default MatchingResultsPage;
